import StudyModelList from "@/view/study/study_model_list";
import StudyModelProposal from "@/view/study/study_model_proposal";

const studyModel = [
  {
    path: "/study",
    component: StudyModelList,
    name: "share_model_status",
    meta: {
      title: 'Solicitação de Estudo',
      auth: false,
    }
  },
  {path: "/study/proposal", component: StudyModelProposal, name: "study_proposal"},
  //{path: "/share_model/:id/show", component: ShareModelShow, name: "share_model_show"},
  //{path: "/share_model/:id/edit", component: ShareModelEdit, name: "share_model_edit"},
  //{path: "/share_model/new", component: ShareModelNew, name: "share_model_new"}
];

export default studyModel;
